var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',_vm._b({staticClass:"date-input form-control",attrs:{"config":_vm.mergedConfig,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)},"blur":function($event){return _vm.$emit('blur', $event)}}},'flat-pickr',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }